import type { SimpleButtonProps } from '../../components/atoms/button/simpleButton';
import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

export type FooterBtn = {
	disabled?: boolean;
	label: string;
	color: SimpleButtonProps['color'];
	size?: SimpleButtonProps['size'];
	onclick: () => void;
	id: string;
	dataTestId: string;
};

type FooterState = {
	footer: {
		buttons: FooterBtn[];
	};
};

type FooterActions = {
	setFooterButtons: (buttons: FooterState['footer']['buttons']) => void;
};

export type FooterSlice = FooterState & FooterActions;

const footerInitialState: FooterState = {
	footer: {
		buttons: [],
	},
};

export function footerSlice(set: NamedSet<ZustandStore>): FooterSlice {
	return {
		...footerInitialState,
		setFooterButtons(buttons: FooterState['footer']['buttons']): void {
			set(
				(state: FooterState) => {
					state.footer.buttons = buttons;
					return state;
				},
				false,
				'[setFooterButtons]',
			);
		},
	};
}
